import React from 'react';

const ArrowDownIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <line x1="12" y1="4" x2="12" y2="20" />
        <polyline points="5 13 12 20 19 13" />
    </svg>
);

export default ArrowDownIcon;
